export default __webpack_public_path__ + "static/media/alert.67c5226e.svg";